import schemaResolver from '.';

/**
 * Event schemata resolver.
 * This pure function transforms an event details object to a list of races schemata.
 */
export const racesResolver = event => event && event.races && event.races.races &&
  event.races.races.map(race => ({
    name: race.title,
    url: event.canonical,
    // Excerpt is optional
    ...(race.excerpt
      ? {
        description: race.excerpt,
      } : event.excerpt && {
        description: event.excerpt,
      }),
    // Start date is optional
    ...(race.startDate && {
      startDate: race.startDate,
    }),
    // Location is optional
    ...(event.location && (event.location.address || (event.location.lat && event.location.lat)) && {
      location: {
        '@type': 'Place',
        // Address is optional
        ...(event.location.address && {
          address: event.location.address.join(', '),
          name: event.location.address.join(', '),
        }),
        // Coordinates are optional
        ...((event.location.lat && event.location.lat) && {
          geo: {
            '@type': 'GeoCoordinates',
            latitude: event.location.lat,
            longitude: event.location.long,
          },
        }),
      },
    }),
    // Image is optional
    ...((event.images && event.images.hero && event.images.hero.title !== 'stub image') && {
      image: [event.images.hero.large],
    }),
    // Organiser is optional
    ...(event.organiser && {
      organizer: {
        '@type': 'Organization',
        name: event.organiser.title,
      },
    }),
    // ...(race.tickets && race.tickets.tickets &&
    //   {
    //     offers: race.tickets.tickets.map((ticket) => {
    //       let availability;
    //       switch (ticket.availabilityType && ticket.availabilityType.type) {
    //         case 1: availability = 'http://schema.org/InStock'; break;
    //         case 2: availability = 'http://schema.org/SoldOut'; break;
    //         default: break;
    //       }
    //       return availability && {
    //         '@type': 'Offer',
    //         price: ticket.discountPrice || ticket.rrp,
    //         priceCurrency: ticket.currencyLabel === '£' ? 'GBP' : 'USD', // TODO
    //         // is this "followable by the Googlebot (not blocked by robots.txt)"
    //         // c.f. https://developers.google.com/search/docs/data-types/event
    //         url: ticket.bookingUrl,
    //         availability,
    //       };
    //     }),
    //   }
    // )
  }));

const resolver = obj => racesResolver(obj).map(r => schemaResolver(r, 'Event'));

export default resolver;



// WEBPACK FOOTER //
// ./app/src/state/resolvers/schema/races.js